import { TrendingUp } from "lucide-react";
import { fmt } from "@/lib/format";

export const SpikeAlert = ({ spikes }) => {
  if (!spikes) return null;
  const rows = spikes.rows || [];
  if (!rows.length) {
    return (
      <p data-testid="spike-alert-none" className="rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-xs text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-300">
        Tidak ada lonjakan Rating Negatif / Laporan Berulang &gt;50% pada {spikes.bulan} dibanding {spikes.prev_bulan}.
      </p>
    );
  }
  return (
    <div data-testid="spike-alert" className="rounded-xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-900 dark:border-rose-900 dark:bg-rose-950/40 dark:text-rose-200">
      <p className="flex items-center gap-2 font-semibold"><TrendingUp className="h-4 w-4" />Peringatan Lonjakan Anomali — {spikes.bulan} vs {spikes.prev_bulan}</p>
      <p className="mt-0.5 text-xs opacity-80">UP3 dengan kenaikan &gt;50% dari bulan sebelumnya (bulan sebelumnya minimal 5 laporan).</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {rows.map((r) => (
          <span key={`${r.unit}-${r.jenis}`} data-testid={`spike-${r.unit}-${r.jenis}`.toLowerCase().replace(/\s+/g, "-")}
            className="rounded-lg border border-rose-300 bg-white px-2.5 py-1 text-xs dark:bg-rose-950">
            <b>{r.unit}</b> · {r.jenis}: <span className="font-num">{r.prev} → {r.cur}</span>
            <b className="ml-1 font-num text-rose-600">+{fmt(r.naik, "pct")}</b>
          </span>
        ))}
      </div>
    </div>
  );
};
